import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentErroServidor from './ContentErroServidor';

const ErroServidor = () => {
  return (
    <>
      <HeaderApp />
      <ContentErroServidor />
      <Bottom />
    </>
  );
};

export default ErroServidor;
